export default "__VITE_ASSET__0fd64732__"